import { Dialog, Button, DialogContent, DialogActions, DialogContentText} from "@mui/material"
import { useGetIdentity, useRedirect, useTranslate } from "react-admin"

const CompleteUserDataDialog = ({handleClose}: {handleClose?: () => void}) => {
  
  const translate = useTranslate()
  const redirect = useRedirect()
  const { data: identity, isLoading } = useGetIdentity()

  if(isLoading || !identity) return null


  const handleConfig = () => {
    redirect(`/users/${identity.id}?resource=invoices`)
    handleClose && handleClose()
  }

  return (
    <>
      <Dialog 
        open={true} 
      >
        <DialogContent>
          <DialogContentText>
            {translate('resources.users.message.notComplete')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfig} >{translate('resources.users.action.complete')}</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default CompleteUserDataDialog